import { render, staticRenderFns } from "./ModalCancelVacinacao.vue?vue&type=template&id=6699d046&scoped=true&"
import script from "./ModalCancelVacinacao.vue?vue&type=script&lang=js&"
export * from "./ModalCancelVacinacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalCancelVacinacao.vue?vue&type=style&index=0&id=6699d046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6699d046",
  null
  
)

export default component.exports